<template>
    <footer class="footer background-image-holder" :class="{ 'special-footer' : $route.meta.specialFooter == true} " v-if="result">

        <medium v-if="$route.meta.showMedium"/>

        <div class="footer__newsletter">
            <h2  v-html="result.setting.data.attributes.Footer.newsletterTitle"></h2>

            <p v-html="result.setting.data.attributes.Footer.NewsletterCaption"></p>

            <div v-if="formStatus.success" class="form-message success">
                {{ formStatus.message }}
            </div>
            
            <div v-else>
                <div v-if="formStatus.error" class="form-message error">
                    {{ formStatus.message }}
                </div>
                <form name="newsletter"
                      @submit.prevent="SubmitNewsletter"
                      aria-label="Newsletter subscription">
                    <div class="form__field">
                        <label for="newsletter-email">Your e-mail address</label>
                        <input 
                            id="newsletter-email"
                            v-model="event.email"
                            name="email"
                            type="email"
                            placeholder="Your e-mail address"
                            required
                            aria-required="true"
                            autocomplete="email"
                            aria-label="Your e-mail address">
                    </div>
                    <button class="general-button" type="submit">Submit</button>
                </form>
            </div>
        </div>

        <div class="footer__bottom">
            <div class="footer__bottom__empty"></div>
            <div class="footer__copyright">
                <div class="footer__copyright__item">
                    Digital Done Properly Since 2014
                </div>
                <div class="footer__copyright__item">
                    © {{new Date().getFullYear()}} Rain Digital
                </div>

            </div>

            <social-menu></social-menu>
        </div>

        <!-- <span class="footer-shape1"><footer-squares/></span>
        <span class="footer-shape2"></span>
        <span class="footer-shape3"></span> -->

        <span class="footer-background">
            <!-- <footer-background/> -->
        </span>

    </footer>
</template>

<script lang="ts">

import { defineComponent, ref, onMounted, watch } from 'vue'

import axios from 'axios'

import { useQuery } from '@vue/apollo-composable'
import { FOOTER_QUERY } from '../../graphql/footer'

import Medium from './Medium.vue'

import SocialMenu from "./SocialMenu.vue";
import InputComponent from '../../components/InputComponent.vue';
import FooterSquares from '../../components/svg/FooterSquares.vue';
import FooterBackground from '../../components/svg/FooterBackground.vue';

export default defineComponent({
    components: {
        InputComponent,
        FooterSquares,
        SocialMenu,
        Medium,
        FooterBackground
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL
        const query = ref(FOOTER_QUERY)
        const { result } = useQuery(query)
        const event = ref({
            email: ''
        });
        const formStatus = ref({
            success: false,
            error: false,
            message: ''
        });

        function SubmitNewsletter() {
            formStatus.value = {
                success: false,
                error: false,
                message: ''
            };

            axios.post(`${homeurl}/api/newsletter/subscribe`, {
                email: event.value.email,
                source: 'footer'
            })
            .then((res) => {
                formStatus.value = {
                    success: true,
                    error: false,
                    message: res.data.message || 'You\'re subscribed! We\'ll be in your inbox soon. 🙌'
                };
                event.value.email = ''; // Clear the form
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || 'Sorry, there was an error submitting your email. Please try again.'
                formStatus.value = {
                    success: false,
                    error: true,
                    message: errorMessage
                };
            });
        }

        return {
            result,
            homeurl,
            event,
            formStatus,
            SubmitNewsletter
        }
    }
})

</script>
